import * as Yup from 'yup';
import { Translations } from 'hooks/Intl';

export default (intl: Translations<string>) =>
  Yup.object().shape({
    advance_days_cooldown: Yup.string().required(intl.FIELD_REQUIRED),
    schedule_period_length: Yup.string().required(intl.FIELD_REQUIRED),
  });
